import React, { useEffect, useState } from "react";
import Down from "../../assets/images/png/chevronDown.png";
import Up from "../../assets/images/png/Vector.png";
import { colors } from "./AccordionBarChart";
import {
  commaSeperated2,
  displayUnit,
  getLimitPer,
} from "../../utils/functions";
export default function AccordionBar({
  item,
  handleToggle,
  index,
  clicked,
  percentTextColor = "#060F1F",
  colorsArray = colors,
  accordionRef,
}) {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const ref = React.createRef();

  useEffect(() => {
    if (ref?.current?.clientWidth < ref?.current?.scrollWidth) {
      setIsOverflowing(true);
    }
  }, [ref, item?.instrument?.name]);

  return (
    <>
      <li
        id={`item-${index}`}
        ref={accordionRef}
        onClick={() => {
          handleToggle(index);
        }}
        className={`accordion_item ${clicked === index ? "active" : ""}`}
      >
        <div
          className="bar"
          style={{
            borderLeftColor: colorsArray[index % colorsArray.length]?.border,
          }}
          key={index}
        >
          <div
            style={{
              "--fill-width": `${item.assetAllocation?.allocation_percentage}%`,
              backgroundColor:
                colorsArray[index % colorsArray.length]?.background,
            }}
            className="fill-animation"
          />
          <span
            style={{
              cursor: isOverflowing ? "pointer" : "text",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              position: "relative",
              paddingLeft: 12,
            }}
          >
            <span
              ref={ref}
              className="content-text"
              style={{ fontWeight: "600" }}
            >
              {item?.groupDescription}
            </span>
            <span
              className="allocation-text"
              style={{
                fontWeight: "500",
                fontFamily: "Roboto",
              }}
            >
              {commaSeperated2(item?.assetAllocation?.currentValue?.value)}
              &nbsp;
              <span className="unitFont">
                {displayUnit(item?.assetAllocation?.currentValue?.value_type)}
              </span>
            </span>
          </span>

          <span
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: 100,
            }}
          >
            <span
              className="percent"
              style={{
                fontWeight: "600",
                // color: "#060F1F",
                color: percentTextColor
                  ? percentTextColor
                  : colorsArray[index % colorsArray.length]?.border,
                minWidth: 70,
              }}
            >
              {item.assetAllocation?.allocation_percentage
                ? getLimitPer(item.assetAllocation?.allocation_percentage)
                : 0}
              %
            </span>
            <img
              src={clicked === index ? Up : Down}
              className="equity-dropdown-icon"
              alt="down"
            />
          </span>
        </div>
      </li>
    </>
  );
}
